// Five Star Trust Bar Slider
(function () {
  function initTrustBar() {

    if (typeof Swiper === "undefined") return;

    document.querySelectorAll(".fs-trust__slider .swiper").forEach(function (slider) {

      if (slider.swiper) return;

      const autoplayEnabled = slider.dataset.autoplay === "true";
      const delay = (parseFloat(slider.dataset.autoplayDelay) || 5) * 1000;

      new Swiper(slider, {
        slidesPerView: 1,
        loop: true,
        speed: 600,
        allowTouchMove: true,

        autoplay: autoplayEnabled
          ? {
              delay: delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: false
            }
          : false
      });
    });

  }

  function waitForSwiper() {
    if (typeof Swiper !== "undefined") {
      initTrustBar();
    } else {
      setTimeout(waitForSwiper, 100);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForSwiper);
  } else {
    waitForSwiper();
  }

  document.addEventListener("shopify:section:load", initTrustBar);

})();